<template>
    <footer class="footer has-cards">
        <div class="container">
            <hr>
            <div class="row justify-content-center align-items-center">
                <div class="copyright">&copy; 2017-2026 广州市锐指盈信息科技有限公司 版权所有</div>
                <div class="icp" v-if="rDomain.icp&&rDomain.icp.length>0">ICP证：<a href="http://beian.miit.gov.cn" target="_blank">{{ rDomain.icp }}</a></div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
.icp {
    padding-left: 1rem;
    font-size: 0.875rem;
    color: #525f7f;
}
</style>
